import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import { useUserContext } from '@/contexts/user';

interface ArgSignupIndexRouteProps {
  Component: FC;
}

const IndexRoute: FC<ArgSignupIndexRouteProps> = ({ Component }) => {
  const { isGuest, isWaiting, isVerified } = useUserContext();

  if (!isGuest) {
    if (isWaiting) {
      return <Navigate to="/signup/redirect" />;
    }
    return <Navigate to="/" />;
  }

  if (isVerified) {
    return <Navigate to="/signup/registration" />;
  }

  return <Component />;
};

export default IndexRoute;
